import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=324ba50b&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=324ba50b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ba50b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324ba50b')) {
      api.createRecord('324ba50b', component.options)
    } else {
      api.reload('324ba50b', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=324ba50b&scoped=true&", function () {
      api.rerender('324ba50b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8EuT8dgEfhFju/JS/comp/PopupBox.vue"
export default component.exports